import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  setReveal: () => void
  setRetry: () => void
}

export const RetryOrRevealModal = ({
  isOpen,
  handleClose,
  setReveal,
  setRetry,
}: Props) => {
  return (
    <BaseModal
      title="Retry or reveal solution?"
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div className="mt-2 flex flex-row space-x-4">
        <button
          type="button"
          className="mt-2 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-center text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-base"
          onClick={() => {
            setRetry()
            handleClose()
          }}
        >
          Retry
        </button>
        <button
          type="button"
          className="mt-2 inline-flex w-full items-center justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-center text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:text-base"
          onClick={() => {
            setReveal()
            handleClose()
          }}
        >
          Reveal solution
        </button>
      </div>
    </BaseModal>
  )
}
